// Базовый URL API из переменных окружения
export const BASE_URL = process.env.REACT_APP_API_URL
export const SOCKET_URL = 'https://rifelli.ru';

// Константы для управления токенами
export const TOKEN_CHECK_INTERVAL = 1 * 60 * 1000; // 15 минут

